import { createBaseAction } from '@essent/common';
import { createAction, props } from '@ngrx/store';
import type { InnogyComponentRendering } from '@core/jss-models';

export const enum CalculateTypes {
  ADD_RENDERING = '[CalculateForm] Add Rendering',
  SUBMIT_RENDERING = '[CalulateForm] submit calculate',
}

export const addCalculationRendering =
  createBaseAction<InnogyComponentRendering>(CalculateTypes.ADD_RENDERING);

export const submitCalculateForm = createBaseAction<
  InnogyComponentRendering | undefined
>(CalculateTypes.SUBMIT_RENDERING);

export const contractIncludesGasInitializationRequested = createAction(
  '[Calculate Form] contractIncludesGas initialization requested',
  props<{ contractIncludesGas: boolean }>()
);
